module.exports = __webpack_public_path__ + "img/E.3c840a70.jpg";